import PermissionsButton from "./PermissionsButton.vue";

export default PermissionsButton;
